import { mutateByFieldTypeSync } from '../../mutate/mutateSync';
import { FormValueChild } from '../../types';

export function addMissingValueFields<T>(template: T): T {
  return mutateByFieldTypeSync(template as FormValueChild, {
    field: (field) => ({ ...field, _value: field._value ?? '' }),
  }) as T;
}
